import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { IoArrowForward, IoShieldCheckmarkOutline, IoCheckmarkDoneOutline } from "react-icons/io5";
import "../auth.css";

function PasswordNewPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");

  const resetPassword = () => {
    setIsLoading(true);
    fetch(`${API_URL}/password/reset`, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone_number: location?.state?.phoneNumber,
        otp: location?.state?.otp,
        new_password: newPassword,
      }),
    })
    .then(r => r.json())
    .then(data => {
      setIsLoading(false);
      if (data.success) {
        toast.success("تم تعيين كلمة المرور بنجاح");
        navigate('/login');
      } else {
        toast.error(data.message || "حدث خطأ أثناء تعيين كلمة المرور");
      }
    })
    .catch(() => {
      setIsLoading(false);
      toast.error("حدث خطأ أثناء تعيين كلمة المرور");
    });
  };

  const match = newPassword === confirmation;
  const canSubmit = !isLoading && newPassword.length >= 8 && match;

  return (
    <div className="auth-screen" dir="rtl">
      <div className="auth-header">
        <button className="auth-back-btn" onClick={() => navigate(-1)}>
          <IoArrowForward size={20} />
        </button>
      </div>

      <div className="auth-content">
        <div className="auth-icon-hero">
          <div className="auth-icon-hero__circle">
            <IoShieldCheckmarkOutline size={34} />
          </div>
          <h1 className="auth-icon-hero__title">كلمة مرور جديدة</h1>
          <p className="auth-icon-hero__sub">أدخل كلمة المرور الجديدة وتأكيدها</p>
        </div>

        <div className="auth-group">
          <label className="auth-label">كلمة المرور الجديدة</label>
          <input
            className="auth-input"
            type="password"
            placeholder="أدخل كلمة المرور الجديدة"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
          />
        </div>

        <div className="auth-group">
          <label className="auth-label">تأكيد كلمة المرور</label>
          <input
            className="auth-input"
            type="password"
            placeholder="أعد إدخال كلمة المرور"
            value={confirmation}
            onChange={e => setConfirmation(e.target.value)}
            style={confirmation && !match ? { borderColor: '#e53935' } : {}}
          />
          {confirmation && !match && (
            <p className="auth-help" style={{ color: '#e53935' }}>كلمتا المرور غير متطابقتين</p>
          )}
        </div>

        <button className="auth-submit" disabled={!canSubmit} onClick={resetPassword}>
          {isLoading
            ? <span className="spinner-border spinner-border-sm" />
            : <IoCheckmarkDoneOutline size={20} />
          }
          تعيين كلمة المرور
        </button>
      </div>
    </div>
  );
}

export default PasswordNewPasswordPage;
